import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import UserRegister from './pages/UserRegister';
import ResetPassword from './pages/ResetPassword';
import PlanUpgrade from './pages/PlanUpgrade';
import Dashboard from './pages/Dashboard';
import WorkerManagement from './pages/WorkerManagement';
import WorkerDetail from './pages/WorkerDetail';
import NoticeManagement from './pages/NoticeManagement';
import ContractSettings from './pages/ContractSettings';
import OvertimeSettings from './pages/OvertimeSettings';
import PlanManagement from './pages/PlanManagement';
import PlanExtend from './pages/PlanExtend';
import Payment from './pages/Payment';
import PaymentDetail from './pages/PaymentDetail';
import RefundRequest from './pages/RefundRequest';
import RefundPolicy from './pages/RefundPolicy';
import PaymentSuccess from './pages/PaymentSuccess';
import StoreInfoManagement from './pages/StoreInfoManagement';
import CustomerSupport from './pages/CustomerSupport';

// 관리자 페이지 임포트
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminCompanyList from './pages/admin/AdminCompanyList';
import AdminCompanyDetail from './pages/admin/AdminCompanyDetail';
import AdminRevenue from './pages/admin/AdminRevenue';
import AdminRefund from './pages/admin/AdminRefund';
import AdminRefundDetail from './pages/admin/AdminRefundDetail';
import AdminRefundPolicy from './pages/admin/AdminRefundPolicy';
import AdminIncomeAnalytics from './pages/admin/AdminIncomeAnalytics';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/user/register" element={<UserRegister />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/plan-upgrade" element={<PlanUpgrade />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        
        {/* 대시보드 라우트 */}
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="worker-management" element={<WorkerManagement />} />
          <Route path="worker-detail/:id" element={<WorkerDetail />} />
          <Route path="notices" element={<NoticeManagement />} />
          <Route path="contract-settings" element={<ContractSettings />} />
          <Route path="overtime-settings" element={<OvertimeSettings />} />
          <Route path="plan-management" element={<PlanManagement />} />
          <Route path="plan-extend" element={<PlanExtend />} />
          <Route path="payment" element={<Payment />} />
          <Route path="payment/:id" element={<PaymentDetail />} />
          <Route path="refund-request/:id" element={<RefundRequest />} />
          <Route path="refund-policy/:id" element={<RefundPolicy />} />
          <Route path="store-info" element={<StoreInfoManagement />} />
          <Route path="customer-support" element={<CustomerSupport />} />
          <Route index element={<Navigate replace to="/dashboard/worker-management" />} />
        </Route>
        
        {/* 관리자 대시보드 라우트 수정 */}
        <Route path="/admin" element={<AdminDashboard />}>
          <Route path="dashboard" element={<AdminCompanyList />} />
          <Route path="company-list" element={<AdminCompanyList />} />
          <Route path="company-detail/:id" element={<AdminCompanyDetail />} />
          <Route path="revenue" element={<AdminRevenue />} />
          <Route path="income-analytics" element={<AdminIncomeAnalytics />} />
          <Route path="support" element={<AdminRefund />} />
          <Route path="refund-detail/:id" element={<AdminRefundDetail />} />
          <Route path="refund-policy" element={<AdminRefundPolicy />} />
          <Route path="settings" element={<AdminIncomeAnalytics />} />
          <Route index element={<Navigate replace to="/admin/company-list" />} />
        </Route>
        
        {/* 존재하지 않는 경로는 로그인 페이지로 리다이렉트 */}
        <Route path="*" element={<Navigate replace to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;